export default "__VITE_ASSET__qa0Ecltk__"